var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hidden),expression:"!hidden"}],staticClass:"circle"},[_c('span',{staticClass:"item-count"},[_vm._v(_vm._s(_vm.itemCount))])])
}
var staticRenderFns = []

export { render, staticRenderFns }